import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { shouldFlip } from 'stories/helpers/theme'

const useStyles = makeStyles((theme) => ({
  checkboxLabel: {
    display: 'block',
    position: 'relative',
    paddingLeft: 35,
    marginBottom: 12,
    cursor: 'pointer',
    fontSize: 22,
    userSelect: 'none',
    '& input': {
      position: 'absolute',
      opacity: 0,
      cursor: 'pointer',
      height: 0,
      width: 0,
    },
    '& input:checked ~ $checkMark': {
      '&::after': { display: 'block' },
    },
  },
  checkMark: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '1.3rem',
    width: '1.3rem',
    borderRadius: 3,
    backgroundColor: 'transparent',
    border: '1px solid',
    transform: shouldFlip(theme) ? 'scaleX(1)' : 'scaleX(-1)',
    '&::after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      left: 3,
      top: 4,
      width: 13,
      height: 7,
      border: 'solid',
      borderWidth: ' 0 3px 3px 0',
      transform: 'rotate(45deg)',
    },
  },
}))
export default function ChoiceCheckBox(props) {
  const classes = useStyles()
  return (
    <label
      className={clsx({
        'formz-field-table-checkbox-choice': true,
        [classes.checkboxLabel]: true,
      })}
    >
      <input type="checkbox" />
      <span
        className={clsx({
          [classes.checkMark]: true,
          checkMark: true,
        })}
      ></span>
    </label>
  )
}
